import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  ROLES,
  CONVERSATION_PERMISSIONS,
} from 'dashboard/constants/permissions.js';
import { FEATURE_FLAGS } from '../../../featureFlags';
import store from 'dashboard/store';

const Panel = () => import('./Panel.vue');
const Pipeline = () => import('./Pipeline.vue');

const beforeEnter = (to, from, next) => {
  const isEnabled = store.getters['accounts/isFeatureEnabledonAccount'](
    to.params.accountId,
    FEATURE_FLAGS.CRM_PIPELINE
  );

  if (!isEnabled) {
    return next(from.fullPath);
  }

  return next();
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm/panel'),
    name: 'crm_panel',
    component: Panel,
    meta: {
      permissions: [...ROLES, ...CONVERSATION_PERMISSIONS],
    },
    beforeEnter,
  },
  {
    path: frontendURL('accounts/:accountId/crm/pipeline'),
    name: 'crm_pipeline',
    component: Pipeline,
    meta: {
      permissions: [...ROLES],
    },
    beforeEnter,
  },
];
